import styles from './GuestHomepage.module.scss';
import TopWelcomeBlock from './TopWelcomeBlock';
import GameBlock from './GameBlock';
import ProviderBlock from './ProviderBlock';
import HeaderGuest from 'Components/_brand/navigations/Header/Guest/HeaderGuest';
import dynamic from 'next/dynamic';
import { IWelcomePackageStrapi } from './types';
import Payments from './Payments/Payments';
import WelcomeCarouselBlock from './WelcomeCarouselBlock/WelcomeCarouselBlock';
import PromoCarouselBlocks from './PromoCarouselBlocks/PromoCarouselBlocks';
import useShowAuthButtons from 'Hooks/useShowAuthButtons';

const JackpotBlock = dynamic(() => import('./JackpotBlock'), { ssr: false });
const BottomCards = dynamic(() => import('./BottomCards/BottomCards'));

interface IGuestHomepage {
  regtype?: any;
  theme?: any;
  payment_methods?: any;
  dynamic_welcome_package?: Array<IWelcomePackageStrapi>;
  free_spins_block: {
    id;
    title;
    description;
    countries_list: Array<string>;
    free_spins_item: Array<{ id; title; image; button_text; second_button_text }>;
  };
}

const GuestHomepage = ({
  regtype,
  theme,
  payment_methods,
  dynamic_welcome_package,
  free_spins_block,
}: IGuestHomepage) => {
  const showBottomCards = useShowAuthButtons();

  return (
    <div className={styles.guesthome_container}>
      <section className={`${styles.header_container}  d-fl ai-c jc-sb`}>
        <HeaderGuest />
      </section>
      <section>
        <TopWelcomeBlock theme={theme} regtype={regtype} />
      </section>
      <div className={`${styles.payments_container} d-fl ai-c jc-c`} key={payment_methods?.length}>
        <Payments payment_methods={payment_methods} />
      </div>
      <div className={`${styles.middle_content}`}>
        <div className={`${styles.container_welcome} top`}>
          <WelcomeCarouselBlock regtype={regtype} free_spins_block={free_spins_block} />
        </div>
        <div className={`${styles.container_promo}`}>
          <PromoCarouselBlocks />
        </div>
        <div className={`${styles.container_game}`}>
          <GameBlock />
        </div>
        <div className={`${styles.container_provider}`}>
          <ProviderBlock regtype={regtype} />
        </div>
        <div className={`${styles.container_jackpot}`}>
          <JackpotBlock />
        </div>
      </div>
      {showBottomCards ?
        <BottomCards dynamic_welcome_package={dynamic_welcome_package} regtype={regtype} />
      : null}
    </div>
  );
};

export default GuestHomepage;
